export default () => {
  const data = {
    event_name: 'tapped_text_field',
    button_name: 'search_street',
    page_section: 'header',
    name_of_the_page_viewed: 'search_personal',
  };
  return data;
};
